import { Pipe, PipeTransform } from '@angular/core';

export function withWidth(url: string, width: number): string {
  return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
}

@Pipe({ name: 'withWidth', standalone: true })
export class WithWidthPipe implements PipeTransform {
  transform(url: string | null | undefined, width: number): string | null {
    if (!url) return null;
    return withWidth(url, width);
  }
}
